// The one nav map. The desktop header and the mobile menu sheet both render
// from it, so a new page only has to be added here.

export interface NavLinkItem {
  name: string;
  to: string;
  // extra path prefixes that also count as "you are here"
  matches?: string[];
}

export interface NavGroup {
  name: string;
  items: NavLinkItem[];
}

export type NavEntry = NavLinkItem | NavGroup;

export const NAV_ENTRIES: NavEntry[] = [
  { name: "home", to: "/" },
  {
    name: "art",
    items: [
      { name: "art of the day", to: "/art-of-the-day" },
      { name: "n450s gallery", to: "/art", matches: ["/artworks"] },
      { name: "AOTD IRL", to: "/aotd-irl" },
    ],
  },
  { name: "blog", to: "/blog" },
  { name: "recipes", to: "/cookbook" },
  {
    name: "coffee",
    items: [
      { name: "coffee rate", to: "/coffee-rate" },
      { name: "coffeeshops", to: "/coffeeshops" },
      { name: "coffee master", to: "/coffee/machines" },
    ],
  },
  {
    name: "store",
    items: [
      { name: "store", to: "/marketplace" },
      { name: "collectibles", to: "/collectibles" },
    ],
  },
  { name: "siteline", to: "/siteline" },
];

export const FOOTER_LINKS: NavLinkItem[] = [
  { name: "about", to: "/about" },
  { name: "contact", to: "/contact" },
  { name: "privacy", to: "/privacy" },
  { name: "cookies", to: "/cookies" },
];

export function isNavGroup(entry: NavEntry): entry is NavGroup {
  return "items" in entry;
}

// While the store is switched off (/admin/marketplace) the store item leaves the header; a menu
// left with one item becomes that item's own tab, so collectibles stands alone.
export function navEntriesFor(storeOpen: boolean): NavEntry[] {
  if (storeOpen) return NAV_ENTRIES;
  return NAV_ENTRIES.map((entry) => {
    if (!isNavGroup(entry) || !entry.items.some((item) => item.to === "/marketplace")) return entry;
    const items = entry.items.filter((item) => item.to !== "/marketplace");
    return items.length === 1 ? items[0] : { ...entry, items };
  });
}

function pathMatches(pathname: string, prefix: string): boolean {
  if (prefix === "/") return pathname === "/";
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

// sub-pages light up their section: /cookbook/pasta is still "recipes"
export function isNavItemActive(pathname: string, item: NavLinkItem): boolean {
  return [item.to, ...(item.matches ?? [])].some((prefix) => pathMatches(pathname, prefix));
}
